import React from 'react'

const Send = () => {
  return (
    <div>Send</div>
  )
}

export default Send